import { Anchor, Text } from '@zillow/constellation-10';

const EXPIRED_TEXT = {
  SINGULAR: 'This file has expired.',
  PLURAL: 'These files have expired.',
};

type Props = {
  isPlural?: boolean;
  onExpiredDetailsClick: () => void;
};

export default function ExpiredAttachmentsText({ isPlural = false, onExpiredDetailsClick }: Props): JSX.Element {
  const mainText = isPlural ? EXPIRED_TEXT.PLURAL : EXPIRED_TEXT.SINGULAR;

  return (
    <Text
      data-testid="attachment-expired-text"
      textStyle="body-xs"
      css={{ color: 'text.subtle', marginBottom: 'tighter' }}
    >
      {mainText}{' '}
      <span>
        <Anchor onClick={onExpiredDetailsClick} css={{ color: 'inherit' }}>
          Details here
        </Anchor>
      </span>
    </Text>
  );
}
